import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

import styled from 'styled-components';

const ShareMenuItem = ({ children, handleClick }) => {
    const StyledShareMenuItem = styled(MenuItem)`
      &.schnoffle-menu-item{
        height: 2.63em;
      }
    `;

    return (
        <StyledShareMenuItem onClick={handleClick} classes={{ root: 'schnoffle-menu-item' }}>
            {children}
        </StyledShareMenuItem>
    );
};

export default ShareMenuItem;



// WEBPACK FOOTER //
// ./src/components/sharing/ShareMenuItem.js